"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokensApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class TokensApi extends runtime.BaseAPI {
    /**
     * Get fungible tokens metadata for given contract id
     * Fungible tokens metadata for contract id
     */
    async getContractFtMetadataRaw(requestParameters, initOverrides) {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId', 'Required parameter requestParameters.contractId was null or undefined when calling getContractFtMetadata.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/tokens/{contractId}/ft/metadata`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.FungibleTokenMetadataFromJSON(jsonValue));
    }
    /**
     * Get fungible tokens metadata for given contract id
     * Fungible tokens metadata for contract id
     */
    async getContractFtMetadata(requestParameters, initOverrides) {
        const response = await this.getContractFtMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get non fungible tokens metadata for given contract id
     * Non fungible tokens metadata for contract id
     */
    async getContractNftMetadataRaw(requestParameters, initOverrides) {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId', 'Required parameter requestParameters.contractId was null or undefined when calling getContractNftMetadata.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/tokens/{contractId}/nft/metadata`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.NonFungibleTokenMetadataFromJSON(jsonValue));
    }
    /**
     * Get non fungible tokens metadata for given contract id
     * Non fungible tokens metadata for contract id
     */
    async getContractNftMetadata(requestParameters, initOverrides) {
        const response = await this.getContractNftMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get list of fungible tokens metadata
     * Fungible tokens metadata list
     */
    async getFtMetadataListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/tokens/ft/metadata`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.FungibleTokensMetadataListFromJSON(jsonValue));
    }
    /**
     * Get list of fungible tokens metadata
     * Fungible tokens metadata list
     */
    async getFtMetadataList(requestParameters, initOverrides) {
        const response = await this.getFtMetadataListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get list of non fungible tokens metadata
     * Non fungible tokens metadata list
     */
    async getNftMetadataListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/tokens/nft/metadata`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.NonFungibleTokensMetadataListFromJSON(jsonValue));
    }
    /**
     * Get list of non fungible tokens metadata
     * Non fungible tokens metadata list
     */
    async getNftMetadataList(requestParameters, initOverrides) {
        const response = await this.getNftMetadataListRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.TokensApi = TokensApi;
//# sourceMappingURL=TokensApi.js.map